
import { Link } from "react-router-dom";

const RecipeCultural = () => {
  return (
    <>
      <h2 className="text-2xl font-medium mb-4">Cultural Significance</h2>
      <p className="text-muted-foreground mb-4">
        Making your own fortune cookies allows you to participate in a beloved tradition while adding your personal touch. While these cookies are often associated with Chinese cuisine in America, they actually have Japanese roots (learn more on our <Link to="/history" className="text-foreground underline">History page</Link>).
      </p>
      <p className="text-muted-foreground mb-8">
        By creating these cookies at home, you're not only making a delicious treat but also continuing a cultural phenomenon that has brought joy and entertainment to millions of people for generations.
      </p>

      <div className="bg-muted p-6 rounded-lg my-8">
        <h3 className="text-xl font-medium mb-2">Need Inspiration?</h3>
        <p className="text-muted-foreground mb-4">
          If you're looking for fortune ideas, check out our <Link to="/" className="text-foreground underline">Daily Fortune</Link> for inspiration, or browse some traditional fortune cookie messages on our <Link to="/faq" className="text-foreground underline">FAQ page</Link>.
        </p>
      </div>
    </>
  );
};

export default RecipeCultural;
